// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IAuction } from '@app/+auctions/shared/types/auctions.type';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-auction-terms-section',
  standalone: true,
  imports: [TranslateModule, TranslateDataPipe],
  templateUrl: './auction-terms-section.component.html',
  styleUrl: './auction-terms-section.component.scss',
})
export class AuctionTermsSectionComponent {
  auction = input.required<IAuction>();
}
